export default __webpack_public_path__ + "static/media/bullsheet-logo.bb98d9fa.png";